import { api, useMutation } from "../../../../hooks"
import type { PinFormValue } from "./pinDialog.schema"

export const usePinDialog = () => {
  const { mutateAsync: save } = useMutation({
    mutationFn: async ({ password }: PinFormValue) => {
      const body = `password=${password}`

      return api.post<{ access_token: string }>(
        "/api/users/security/step-up/login",
        {
          body,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      )
    },
  })

  return {
    save,
  }
}
